import Swal from "sweetalert2"
import withReactContent from "sweetalert2-react-content"

const MySwal = withReactContent(Swal)

export function missingInfoAlert() {
  MySwal.fire({
    icon: "error",
    title: "Oops...",
    text:
      "Some information that is provided is not correct. Please check again. Thank you.",
  })
}

export function policyValidationAlert() {
  MySwal.fire({
    icon: "error",
    title: "Oops...",
    text:
      "Policy Number / Policyholder's name does not match our records. Please check again. Thank you.",
  })
}

export function largeUploadedFile() {
  Swal.fire({
    icon: "warning",
    title: "Notice",
    text:
      "Large file size is detected, we will automatically compress the file, and this may take a few minutes to complete. We appreciate your patience.",
  })
}

export function errorWhenUpload() {
  Swal.fire({
    icon: "warning",
    title: "Notice",
    text:
      "Error while processing, kindly delete and reupload the file. Thank you.",
  })
}

export function missingProvideDocumentProofOfClaimAlert() {
  MySwal.fire({
    icon: "error",
    title: "Oops...",
    text: "Please provide document for proof of claim. Thank you.",
  })
}

export function pleaseAgreeAlert() {
  MySwal.fire({
    icon: "error",
    title: "Oops...",
    text: "Please agree with the Terms & Conditions to proceed. Thank you.",
  })
}

export function missingProvideBenefitDocumentAlert() {
  MySwal.fire({
    icon: "error",
    title: "Oops...",
    text: "Please provide required supporting document. Thank you.",
  })
}

export function atLeastUploadOneFileAlert() {
  MySwal.fire({
    icon: "error",
    title: "Oops...",
    text: "Please provide at least one supporting document. Thank you.",
  })
}

export function fillMedicalDetailAlert() {
  MySwal.fire({
    icon: "error",
    title: "Oops...",
    text:
      "Please fill in all the information for medical details. Please check again. Thank you.",
  })
}

export function fillOtherBenefitsAlert() {
  MySwal.fire({
    icon: "error",
    title: "Oops...",
    text:
      "Please fill in all the information for other benefits. Please check again. Thank you.",
  })
}
